import { useEffect, useRef } from 'react';
import { AppState, type AppStateStatus } from 'react-native';

/**
 * Καλεί το callback κάθε φορά που η εφαρμογή επιστρέφει στο foreground.
 * Χρήσιμο για screens που χρειάζονται ανανέωση δεδομένων μετά από αδράνεια,
 * ειδικά όταν ο χρήστης είναι ήδη στο tab και το useFocusEffect δεν ξανατρέχει.
 */
export function useOnAppActive(callback: () => void) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const appStateRef = useRef<AppStateStatus>(AppState.currentState);

  useEffect(() => {
    const sub = AppState.addEventListener('change', (nextState) => {
      if (appStateRef.current !== 'active' && nextState === 'active') {
        callbackRef.current();
      }
      appStateRef.current = nextState;
    });
    return () => sub.remove();
  }, []);
}
